function getCart(){
  var customer = document.querySelector("#customercheck");
  var customer_exist = parseInt(customer.getAttribute("customercheck"));
   
  fetch('/cart.js')
 .then((response) => response.json())
 .then((response) => {
   response.items.forEach(function(element){
     // if(element.selling_plan_allocation){
     //   if(customer_exist == 1){
     //     document.querySelector('.custom-offer-text').classList.add('show')
     //   }else{
     //     document.querySelector('.requiredLoginMessag').setAttribute("hidden", "false");
     //     document.querySelector("#CartDrawer-Checkout").setAttribute("disabled", "disabled");
     //   }
     // }
   })
 })
}
getCart();

$(document).on('change','.cartautoship',function(event){
event.preventDefault();

var $this = $(this); // Capture the context of `this`
var txt = $this.find(":selected").text();

//Check if customer exists
var customer = document.querySelector("#customercheck");
var customer_exist = parseInt(customer.getAttribute("customercheck"));

// console.log(txt)
var vid = $this.attr('variant');
var selplan = $this.find(":selected").val();
var deliveryCount = 0;
if($("#CartDrawer-CartItems").length > 0){
 $("#CartDrawer-CartItems").find(".cartautoship").each(function(index){
     var  delType = $(this).find(":selected").text();
     var delTypeVal = delType.replace(/ .*/,'')
     if(delTypeVal == 'Delivery'){
         // console.log('dfsdf64375476')
        deliveryCount++;
     }
   if(customer_exist && deliveryCount == 0){
     document.querySelector('.custom-offer-text').classList.remove('show')
   }else if(customer_exist && deliveryCount > 0){
     document.querySelector('.custom-offer-text').classList.add('show')
   }
   if(deliveryCount > 0 && !customer_exist){
       // $('#cart_checkout_without_dic').prop("disabled", true)
       $("#message").removeAttr("hidden")
     }
   else{
     // $('#cart_checkout_without_dic').prop("disabled", false)
      $("#message").attr("hidden", true)
   
      
   }
  
}) 
}
var deliveryCartCount = 0;
if($("#cart_page_data_items").length > 0){
 $("#cart_page_data_items").find(".cartautoship").each(function(index){
     var  delTypeCart = $(this).find(":selected").text();
     var delTypeCartVal = delTypeCart.replace(/ .*/,'')
      // console.log(delTypeCartVal)
     if(delTypeCartVal == 'Delivery'){
        deliveryCartCount++;
     }
      // console.log(deliveryCartCount)
   if(deliveryCartCount > 0){
       // $("#checkout").prop("disabled", true)
       $("#message_cart_page").removeAttr("hidden")
     }
   else{
     //  $("#checkout").removeAttr("disabled")
     $("#message_cart_page").attr("hidden", true)
   }
  
}) 
}





var qty =  $this.parents('.custom-product-title').find('.cart-item__quantity-wrapper .quantity.cart-quantity input').val();
const currency_symbol = $('#CartDrawer').attr('currency');
$.ajax({
   type: 'POST',
   url: '/cart/change.js',
   data: { 'id': vid, 'selling_plan': selplan , 'quantity' : qty },
   success: function(response) {
       const resp = JSON.parse(response)
       $this.parents('.custom-product-title').find('.sellingplanopt').text(txt);
       $('#CartDrawer-CartErrors').hide()
       resp.items.forEach(function (item) {
         if(item.id == vid){
            $this.parents('.custom-product-title').find('.cart-item__price-wrapper span').text(currency_symbol+item.original_line_price/100)
            $this.parents('.custom-product-title').find('.product-option.price').text(currency_symbol+item.presentment_price);
           $('.cart__checkout-button p').text(currency_symbol+resp.total_price/100)
         }
       })
   },
   error: function(xhr, status, error) {
       console.error("An error occurred: " + error);
   }
});
});


$( document ).ready(function() {
setTimeout(function(){
var ondeliveryCartCount = 0;
 $("#cart_page_data_items").find(".cartautoship").each(function(index){
     var  ondelTypeCart = $(this).find(":selected").text();
     var ondelTypeCartVal = ondelTypeCart.replace(/ .*/,'')
     if(ondelTypeCartVal == 'Delivery'){
        ondeliveryCartCount++;
     }
   if(ondeliveryCartCount > 0){
       // $("#checkout").prop("disabled", true)
        $("#message_cart_page").removeAttr("hidden")
     }
   else{
     //  $("#checkout").removeAttr("disabled")
     $("#message_cart_page").attr("hidden", true)
   }
  
}) 
},2000)


})


class CartRemoveButton extends HTMLElement {
constructor() {
super();

this.addEventListener('click', (event) => {
 event.preventDefault();
 const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
 cartItems.updateQuantity(this.dataset.index, 0);
});
}
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
constructor() {
super();
this.lineItemStatusElement =
 document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

const debouncedOnChange = debounce((event) => {
 this.onChange(event);
}, ON_CHANGE_DEBOUNCE_TIMER);

this.addEventListener('change', debouncedOnChange.bind(this));
}

cartUpdateUnsubscriber = undefined;

connectedCallback() {
this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
 if (event.source === 'cart-items') {
   return;
 }
 this.onCartUpdate();
});
}

disconnectedCallback() {
if (this.cartUpdateUnsubscriber) {
 this.cartUpdateUnsubscriber();
}
}

onChange(event) {

this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
}

onCartUpdate() {
if (this.tagName === 'CART-DRAWER-ITEMS') {
 fetch(`${routes.cart_url}?section_id=cart-drawer`)
   .then((response) => response.text())
   .then((responseText) => {
     const html = new DOMParser().parseFromString(responseText, 'text/html');
     const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
     for (const selector of selectors) {
       const targetElement = document.querySelector(selector);
       const sourceElement = html.querySelector(selector);
       if (targetElement && sourceElement) {
         targetElement.replaceWith(sourceElement);
       }
     }
   })
   .catch((e) => {
     console.error(e);
   });
} else {
 fetch(`${routes.cart_url}?section_id=main-cart-items`)
   .then((response) => response.text())
   .then((responseText) => {
     const html = new DOMParser().parseFromString(responseText, 'text/html');
     const sourceQty = html.querySelector('cart-items');
     this.innerHTML = sourceQty.innerHTML;
   })
   .catch((e) => {
     console.error(e);
   });
}
}

getSectionsToRender() {
return [
 {
   id: 'main-cart-items',
   section: document.getElementById('main-cart-items').dataset.id,
   selector: '.js-contents',
 },
 {
   id: 'cart-icon-bubble',
   section: 'cart-icon-bubble',
   selector: '.shopify-section',
 },
 {
   id: 'cart-live-region-text',
   section: 'cart-live-region-text',
   selector: '.shopify-section',
 },
 {
   id: 'main-cart-footer',
   section: document.getElementById('main-cart-footer').dataset.id,
   selector: '.js-contents',
 },
];
}

updateQuantity(line, quantity, name, variantId) {
this.enableLoading(line);
var customer = document.querySelector("#customercheck");
var customer_exist = parseInt(customer.getAttribute("customercheck"));
const body = JSON.stringify({
 line,
 quantity,
 sections: this.getSectionsToRender().map((section) => section.section),
 sections_url: window.location.pathname,
});

fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
 .then((response) => {
   return response.text();
 })
 .then((state) => {
   const parsedState = JSON.parse(state);
     parsedState.items.forEach(function(element){
         var output2 = 'selling_plan_allocation' in element;
        if(element.selling_plan_allocation){
           if(customer_exist == 1){
             setTimeout(function(params) {
                document.querySelector('.custom-offer-text').classList.add('show')
             },500)
            
           }else{
             setTimeout(function(){
                 // document.querySelector('.requiredLoginMessag').setAttribute("hidden", "false");
                 // document.querySelector("#CartDrawer-Checkout").setAttribute("disabled", "disabled");
             },500)
             
           }
         }
       })
   const quantityElement =
     document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
   const items = document.querySelectorAll('.cart-item');

   if (parsedState.errors) {
     quantityElement.value = quantityElement.getAttribute('value');
     this.updateLiveRegions(line, parsedState.errors);
     return;
   }

   this.classList.toggle('is-empty', parsedState.item_count === 0);
   const cartDrawerWrapper = document.querySelector('cart-drawer');
   const cartFooter = document.getElementById('main-cart-footer');

   if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
   if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

   this.getSectionsToRender().forEach((section) => {
     const elementToReplace =
       document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
     elementToReplace.innerHTML = this.getSectionInnerHTML(
       parsedState.sections[section.section],
       section.selector
     );
   });
   const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
   let message = '';
   if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
     if (typeof updatedValue === 'undefined') {
       message = window.cartStrings.error;
     } else {
       message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
     }
   }
   this.updateLiveRegions(line, message);

   const lineItem =
     document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
   if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
     cartDrawerWrapper
       ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
       : lineItem.querySelector(`[name="${name}"]`).focus();
   } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
     trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
   } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
     trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
   }

   publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
   
 })
 .catch(() => {
   this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
   const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
   errors.textContent = window.cartStrings.error;
 })
 .finally(() => {
   this.disableLoading(line);
 });
}

updateLiveRegions(line, message) {
const lineItemError =
 document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

this.lineItemStatusElement.setAttribute('aria-hidden', true);

const cartStatus =
 document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
cartStatus.setAttribute('aria-hidden', false);

setTimeout(() => {
 cartStatus.setAttribute('aria-hidden', true);
}, 1000);
}

getSectionInnerHTML(html, selector) {
return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

enableLoading(line) {
const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
mainCartItems.classList.add('cart__items--disabled');

const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

document.activeElement.blur();
this.lineItemStatusElement.setAttribute('aria-hidden', false);
}

disableLoading(line) {
const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
mainCartItems.classList.remove('cart__items--disabled');

const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
}
}

customElements.define('cart-items', CartItems);

$(document).on('click', '.rebuy-product-actions', function() {
setTimeout(function(){
fetch(`${routes.cart_url}?section_id=cart-drawer`)
.then((response) => response.text())
.then((responseText) => {
 const html = new DOMParser().parseFromString(responseText, 'text/html');
 const selectors = ['cart-drawer-items', '.drawer__footer'];
 for (const selector of selectors) {
   const targetElement = document.querySelector(selector);
   const sourceElement = html.querySelector(selector);
   if (targetElement && sourceElement) {
     targetElement.replaceWith(sourceElement);
   }
 }
 getCart();
   $('.drawer__inner-empty').remove()
   $('cart-drawer.drawer').removeClass('is-empty')
   $('cart-drawer.drawer').addClass('active')
})
.catch((e) => {
 console.error(e);
});
},1200)
});



if (!customElements.get('cart-note')) {
customElements.define(
'cart-note',
class CartNote extends HTMLElement {
 constructor() {
   super();

   this.addEventListener(
     'input',
     debounce((event) => {
       const body = JSON.stringify({ note: event.target.value });
       fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
     }, ON_CHANGE_DEBOUNCE_TIMER)
   );
 }
}
);
}

$(document).keypress(
function(event){
if (event.which == '13') {
 event.preventDefault();
}
});
